import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
import hiddenStyles from './Hidden.scss';
const DeviationBlockedOverlay = (_param)=>{
    var { deviation: { deviationId, author }, deviation, blockDeviant, unhideDeviation } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation",
        "blockDeviant",
        "unhideDeviation"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.deviation'),
        text: /*#__PURE__*/ React.createElement(React.Fragment, null, t('deviationview.blocked.deviation.text'), /*#__PURE__*/ React.createElement("br", null), t('deviationview.blocked.deviation.text2')),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: "medium",
            onClick: ()=>author && blockDeviant(author, deviationId)
        }, t('deviationview.blocked.blockDeviant')),
        secondaryButton: author && /*#__PURE__*/ React.createElement("button", {
            className: hiddenStyles['secondary-button'],
            onClick: ()=>unhideDeviation(deviationId)
        }, t('deviationview.blocked.unhideDeviation'))
    }, props));
};
DeviationBlockedOverlay.displayName = 'DeviationBlockedOverlay';
export default DeviationBlockedOverlay;

//# sourceMappingURL=DeviationBlocked.js.map